import { useSelector } from 'react-redux'
import { uxSensorModeKindSelector } from '@src/selectors/app'
import { UserExperienceSensorModeKind } from '@src/types'

export const useIsDexcomG6G7Realtime = () => {
  const uxSensorModeKind = useSelector(uxSensorModeKindSelector)

  return (
    uxSensorModeKind === UserExperienceSensorModeKind.OwnSensorDexcomG6 ||
    uxSensorModeKind === UserExperienceSensorModeKind.OwnSensorDexcomG7
  )
}
